<script setup lang="ts">
const { messages, hasMessages, messageCount, dismiss } = usePermanentMessages();
const { t } = useI18n();

const popoverOpen = ref(false);

function colorForType(type: string): 'warning' | 'error' | 'info' {
  if (type === 'error') return 'error';
  if (type === 'warning') return 'warning';
  return 'info';
}
</script>
<template>
  <UPopover v-if="hasMessages" v-model:open="popoverOpen" :ui="{ content: 'w-80' }">
    <UChip :text="messageCount" size="2xl" color="warning" position="top-left">
      <UButton icon="heroicons:bell-alert" variant="link" size="xl" class="m-0 p-0" />
    </UChip>
    <template #content>
      <div class="p-3 flex flex-col gap-2">
        <div
          v-for="msg in messages"
          :key="msg.dismissKey"
          class="flex items-start gap-2 p-2 rounded-md"
          :class="{
            'bg-warning/10': !msg.dismissed && msg.type === 'warning',
            'bg-error/10': !msg.dismissed && msg.type === 'error',
            'bg-info/10': !msg.dismissed && msg.type === 'info',
          }"
        >
          <UIcon :name="msg.icon" class="text-xl mt-0.5 shrink-0" :class="`text-${colorForType(msg.type)}`" />
          <div class="flex-1 min-w-0">
            <div class="font-medium text-sm">{{ t(msg.titleKey, msg.params) }}</div>
            <div class="text-xs text-muted">{{ t(msg.messageKey, msg.params) }}</div>
            <div class="flex gap-2 mt-1">
              <UButton
                v-if="msg.action"
                :label="t(msg.action.labelKey)"
                variant="link"
                size="xs"
                :to="msg.action.route"
                @click="popoverOpen = false"
              />
              <UButton v-if="!msg.dismissed" :label="t('permanent.dismiss')" variant="link" size="xs" color="neutral" @click="dismiss(msg)" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </UPopover>
</template>
